import { render } from "./auths-table.component.vue?vue&type=template&id=299a2156"
import script from "./auths-table.component.vue?vue&type=script&lang=js"
export * from "./auths-table.component.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./auths-table.component.vue?vue&type=style&index=0&id=299a2156&lang=css&module=true"
cssModules["$style"] = style0

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__